export default __webpack_public_path__ + "static/media/Shemite Wayfarer Boots.5874636f.jpg";